<template>
  <div class="container">
    <h4>
      three.js garage goes here. if you need cars - get low-poly cartoony ones
      on
      <a href="https://www.kenney.nl/assets/car-kit"
        >https://www.kenney.nl/assets/car-kit</a
      >
    </h4>
    <button
      style="position: absolute; z-index: 10"
      type="button"
      class="btn btn-primary"
      @click="() => chooseRandomCar()"
    >
      Choose random car
    </button>
    <div class="three" ref="threeContainer"></div>
  </div>
</template>
<script>
import * as THREE from "three";
import { load } from "./three/ObjLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import SpriteText from 'three-spritetext';

const MODELS = [
  "taxi",
  "suv",
  "suvLuxury",
  "race",
  "police",
  "hatchbackSports",
  "firetruck",
];
const GARAGE_LAYOUT = [
  ["taxi", "suv", "suvLuxury"],
  ["race", "police", "hatchbackSports"],
  ["firetruck"],
];
const PLANE_SIZE = 3,
  PADDING = 1;
let camera, scene, renderer, controls;
let mesh,
  cars = new Map();

export default {
  methods: {
    async init() {
      const element = this.$refs.threeContainer;
      const WIDTH = element.offsetWidth,
        HEIGHT = element.offsetHeight;
      camera = new THREE.PerspectiveCamera(70, WIDTH / HEIGHT, 1, 1000);
      camera.position.z = 3;
      camera.position.y = 1;

      scene = new THREE.Scene();

      const ambientLight = new THREE.AmbientLight(0xcccccc, 1);
      scene.add(ambientLight);

      for (let i = 0; i < GARAGE_LAYOUT.length; i++) {
        for (let j = 0; j < GARAGE_LAYOUT[i].length; j++) {
          const plane = this.createGround();
          scene.add(plane);
          const carName = GARAGE_LAYOUT[i][j];
          const text = this.createLabel(carName);
          scene.add(text);
          this.loadCar(carName).then((obj) => {
            scene.add(obj);
            obj.position.x += (PLANE_SIZE + PADDING) * i;
            obj.position.z += (PLANE_SIZE + PADDING) * j;
            text.position.set(
                obj.position.x , 
                obj.position.y, 
                obj.position.z+ PLANE_SIZE / 2);
            cars.set(carName, obj);
          });
          plane.position.x += (PLANE_SIZE + PADDING) * i;
          plane.position.z += (PLANE_SIZE + PADDING) * j;
        }
      }

      renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(WIDTH, HEIGHT);
      this.$refs.threeContainer.appendChild(renderer.domElement);
      controls = new OrbitControls(camera, renderer.domElement);
      controls.update();
    },

    createGround() {
      const geometry = new THREE.PlaneGeometry(3, 3);
      const material = new THREE.MeshBasicMaterial({
        color: 0x333333,
        side: THREE.DoubleSide,
      });
      const plane = new THREE.Mesh(geometry, material);
      plane.rotation.x = 1.6;
      return plane;
    },

    createLabel(text) {
        let label = new SpriteText(text, 0.25, 'black');
        label.backgroundColor = 'silver';
        return label;
    },

    async loadCar(modelName) {
      try {
        mesh = await load(
          "public/obj/",
          `${modelName}.obj`,
          `${modelName}.mtl`
        );
      } catch (e) {
        console.error(e);
      }
      return mesh;
    },

    chooseRandomCar() {
      const carIndex = Math.trunc(MODELS.length * Math.random()) - 1;
      const obj = cars.get(MODELS[carIndex]);
      camera.position.set(obj.position.x, camera.position.y , obj.position.z - PLANE_SIZE/2);
      camera.updateProjectionMatrix();
    },
  },

  async mounted() {
    await this.init();
    animate();

    function animate() {
      controls.update();
      requestAnimationFrame(animate);

      renderer.render(scene, camera);
    }
  },
};
</script>
<style>
.three {
  width: 100vw;
  height: 80vh;
  display: flex;
  position: absolute;
  top: 10vh;
  left: 0;
}
</style>